import { useParams } from "react-router";
import RecipeDetails from "../../components/recipe/RecipeDetails";

export default function RecipeDetailsPage() {
  const { uuid } = useParams();
  return <RecipeDetails recipeUuid={uuid ?? ""} />;
}
